import { Trans } from '@lingui/macro'
import { authRoles } from 'app/auth/authRoles'
import { RouteConfig } from 'app/router/Routes'
import { EgretLoadable } from 'egret'
import { DMAH_PATHS } from './DMAHConstants'

const dmahRoutes: RouteConfig[] = [
  {
    path: DMAH_PATHS.APPLICATIONS,
    component: EgretLoadable({
      loader: async () => await import('./DMAHApplications')
    }),
    auth: authRoles.DMAH,
    isTranslatable: true,
    label: <Trans>DMAH_TAB</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: `${DMAH_PATHS.APPLICATION}/:id`,
    component: EgretLoadable({
      loader: async () => await import('./DMAHView')
    }),
    auth: authRoles.DMAH,
    label: <Trans>DMAH_ROUTES_DMAH_APPLICATION_ROUTE_LABEL</Trans>,
    isConditionable: true,
    id: 'dmah-application',
    showCollapseBtn: true,
    collapseByDefault: true
  }
]

export default dmahRoutes
